import React, { useEffect, useRef, useState } from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { HuchaCardBackground } from '../../ui/hucha-card-background';
import { HuchaRenovadoresCardC1 } from './hucha-renovadores-card-c1';
import { HuchaRenovadoresCardC2 } from './hucha-renovadores-card-c2';
import { HuchaRenovadoresCardC3 } from './hucha-renovadores-card-c3';
import styled from 'styled-components';

const RenovadoresHuchaCardContainer = styled.div`
	display: flex;
	flex-direction: column;

	gap: var(--size-dynamic0200);

	@media (min-width: 560px) {
		flex-direction: row;
		justify-content: center;
		align-items: center;

		& > div[data-testid='c1-container'] {
			flex: 1;
		}
		& > div[data-testid='c2-container'] {
			flex: 1;
		}
		& > div[data-testid='c3-container'] {
			flex: 2.5;
		}

		/* clase que se aplica cuando supera el ancho límite */
		&.small-hucha-layout {
			flex-wrap: wrap;
			& > div[data-testid='c1-container'] {
				flex: 1;
			}
			& > div[data-testid='c2-container'] {
				flex: 1;
			}
			& > div[data-testid='c3-container'] {
				flex: 0 0 100%;
			}
		}
	}
`;

export const HuchaRenovadoresCard = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [isSmallHuchaLayout, setIsSmallHuchaLayout] = useState(false);
	const WIDTH_LIMIT = 880;

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;

		const updateWidthState = () => {
			setIsSmallHuchaLayout(el.offsetWidth <= WIDTH_LIMIT);
		};

		updateWidthState();

		let observer: ResizeObserver | undefined;
		if (typeof ResizeObserver !== 'undefined') {
			observer = new ResizeObserver(updateWidthState);
			observer.observe(el);
		}

		window.addEventListener('resize', updateWidthState);

		return () => {
			observer?.disconnect();
			window.removeEventListener('resize', updateWidthState);
		};
	}, []);

	return (
		<HuchaCardBackground stretchContent data-testid="hucha-venta-card-container" wrap={'never'}>
			<RenovadoresHuchaCardContainer ref={containerRef} className={isSmallHuchaLayout ? 'small-hucha-layout' : ''}>
				<HuchaRenovadoresCardC1 huchaValues={huchaValues} />
				<HuchaRenovadoresCardC2 dineroHucha={huchaValues?.dineroHucha || '0'} />
				<HuchaRenovadoresCardC3 huchaValues={huchaValues} />
			</RenovadoresHuchaCardContainer>
		</HuchaCardBackground>
	);
};
